{
  "common": {
    "save": "Mentés",
    "cancel": "Mégse",
    "delete": "Törlés",
    "edit": "Szerkesztés",
    "create": "Létrehozás",
    "search": "Keresés",
    "loading": "Betöltés...",
    "back": "Vissza",
    "next": "Tovább",
    "yes": "Igen",
    "no": "Nem",
    "ok": "OK",
    "close": "Bezárás",
    "open": "Megnyitás",
    "name": "Név",
    "email": "E-mail",
    "phone": "Telefon",
    "language": "Nyelv",
    "settings": "Beállítások",
    "logout": "Kijelentkezés",
    "today": "Ma",
    "yesterday": "Tegnap",
    "thisMonth": "Ez a hónap",
    "lastMonth": "Múlt hónap",
    "from": "Tól",
    "to": "Ig",
    "load": "Betöltés",
    "all": "Mind",
    "active": "Aktív",
    "inactive": "Inaktív",
    "saved": "Mentve",
    "error": "Hiba",
    "noData": "Nincs adat"
  },
  "sidebar": {
    "restaurantManagement": "Étterem kezelés",
    "dashboard": "Áttekintés",
    "newOrder": "Új rendelés",
    "preorders": "Előrendelések",
    "kitchen": "Konyha",
    "dispatch": "Kiszállítás - tábla",
    "restaurant": "Étterem",
    "tableMap": "Asztal térkép",
    "kitchenManagement": "Konyha kezelése",
    "categories": "Kategóriák",
    "products": "Termékek",
    "lunchMenu": "Ebéd menü",
    "kombo": "Kombó BOX",
    "pizza": "Pizza",
    "stockManagement": "Készletkezelés",
    "stock": "Készletkezelés",
    "recipes": "Receptek",
    "beverageStock": "Italok raktár",
    "analytics": "Analitika",
    "statistics": "Statisztikák",
    "summaries": "Összefoglalók",
    "marketing": "Marketing",
    "employees": "Alkalmazottak",
    "attendance": "Jelenlét",
    "systemSettings": "Rendszerbeállítások"
  },
  "profile": {
    "title": "Profilom",
    "tabs": {
      "personal": "Személyes adatok",
      "security": "Biztonság",
      "performance": "Teljesítményem",
      "attendance": "Jelenlétem"
    },
    "firstName": "Keresztnév",
    "lastName": "Vezetéknév",
    "save": "Változások mentése"
  },
  "attendance": {
    "arrive": "Érkezés",
    "leave": "Távozás",
    "notInShift": "Műszakon kívül",
    "inShift": "Műszakban",
    "shiftClosed": "Műszak lezárva"
  }
}
